import { Item } from "@/types/fse";
import { FlattenedItem } from "@/views/chat/types";

export const truncateSummary = (summary: string, wordLimit: number = 200) => {
  const lines = summary.split("\n");
  let wordCount = 0;
  const truncatedLines = [];

  for (const line of lines) {
    const words = line.split(/\s+/);
    if (wordCount + words.length <= wordLimit) {
      truncatedLines.push(line);
      wordCount += words.length;
    } else {
      const remainingWords = wordLimit - wordCount;
      if (remainingWords > 0) {
        truncatedLines.push(words.slice(0, remainingWords).join(" "));
      }
      break;
    }
  }

  return truncatedLines.join("\n") + (wordCount < summary.split(/\s+/).length ? "..." : "");
};

export const flatFileSystem = (
  item: Item,
  depth: number = 0,
  expandedFolders: Set<string> | undefined,
  showFolders: boolean,
): FlattenedItem[] => {
  if (item.type === "file") {
    return [{ ...item, depth, isExpanded: false }];
  }

  const isExpanded = expandedFolders?.has(item.id) || true;
  const result: FlattenedItem[] = showFolders ? [{ ...item, depth, isExpanded }] : [];

  if (isExpanded || !showFolders) {
    Object.values(item.items).forEach((subItem: Item) => {
      result.push(...flatFileSystem(subItem, showFolders ? depth + 1 : depth, expandedFolders, showFolders));
    });
  }

  return result;
};
